import React, { useEffect, useState } from 'react';
import ListaLinksScroleable from '../UI/ListaLinksScroleable';
import * as TipoParticipacion from '../constantes/TipoParticipacionTorneo.js';
import MensajeCargando from '../UI/MensajeCargando';
import MensajeError from '../UI/MensajeError';
import useGetListaURL from '../../hooks/useGetListaURL';

const ListaTiposTorneoOrganizadorInt = (props) => {
  const organizador = props.organizador;
  const [tiposTorneo, setTiposTorneo] = useState([]);
  const { isCargando, erroresGetLista, fetchData, resetErroresGetLista } = useGetListaURL();

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  useEffect(() => {
    if (!organizador || !organizador.oficialidad) {
      setTiposTorneo([]);
      return;
    }

    const url =
      'tipos_torneo?oficialidad=' +
      organizador.oficialidad +
      '&tipoParticipacion=' +
      TipoParticipacion.CLUBES;
    fetchData(url, (lista) => {
      const listaNormalizada = Array.isArray(lista)
        ? lista.map((tipoTorneo, index) => ({
            id: tipoTorneo.codigo ? tipoTorneo.codigo : tipoTorneo.id || index,
            nombre: tipoTorneo.nombre || tipoTorneo.descripcion || '',
            vigente: Boolean(tipoTorneo.vigente),
            nivel:
              tipoTorneo.nivel === null || tipoTorneo.nivel === undefined || tipoTorneo.nivel === ''
                ? Number.MAX_SAFE_INTEGER
                : Number.isFinite(Number(tipoTorneo.nivel))
                  ? Number(tipoTorneo.nivel)
                  : Number.MAX_SAFE_INTEGER,
          }))
        : [];

      listaNormalizada.sort((a, b) => {
        if (a.vigente !== b.vigente) {
          return a.vigente ? -1 : 1;
        }

        if (a.nivel !== b.nivel) {
          return a.nivel - b.nivel;
        }

        return a.nombre.localeCompare(b.nombre, 'es', { sensitivity: 'base' });
      });

      setTiposTorneo(listaNormalizada);
    });
  }, [organizador, fetchData]);

  return (
    <React.Fragment>
      <ListaLinksScroleable
        path="/torneosInt/"
        lista={tiposTorneo}
        cantVisibles={6}
        altoFijo={true}
      />
      <MensajeCargando isCargando={isCargando} />
      <MensajeError errores={erroresGetLista} />
    </React.Fragment>
  );
};

export default ListaTiposTorneoOrganizadorInt;
